import { APIFieldType } from '@ardoq/api-types';
import {
  PermissionContext,
  permissionsOperations,
} from '@ardoq/access-control';
import {
  getStartDateName,
  dateRangeOperations,
  isDateRangeFieldType,
} from '@ardoq/date-range';
import { colors } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import type { SelectOption } from '@ardoq/select';

const toNormalizedFieldName = (name: string, type?: APIFieldType): string => {
  if (type && isDateRangeFieldType(type)) {
    return dateRangeOperations.toStartDateName(name);
  }
  if (dateRangeOperations.isCombinedDateRangeFieldNames(name)) {
    return getStartDateName(name);
  }
  return name;
};

/**
 * Checks whether a field is confidential, normalizing date range field names
 * before the check. Prefer this instead of `permissionsOperations.fieldIsConfidential`
 * directly.
 */
export const fieldIsConfidential = (
  permissionContext: PermissionContext,
  { name, type }: { name: string; type?: APIFieldType }
): boolean => {
  const nameToCheck = toNormalizedFieldName(name, type);
  return permissionsOperations.fieldIsConfidential(
    permissionContext,
    nameToCheck
  );
};

type WarningMessagePlacement = 'description' | 'popoverContent';

export const toConfidentialFieldSelectOption = <T>(
  option: SelectOption<T>,
  warningMessage: string,
  warningAs: WarningMessagePlacement
): SelectOption<T> => ({
  ...option,
  [warningAs]: warningMessage,
  rightIcon: { name: IconName.CONTROL, color: colors.iconWarning },
  rightIconName: undefined,
});
